import { SavedBerichtModel } from 'app/models/saved.bericht.model';
import { BaseCachedEntityStore } from './core/base.cached.entity.store';

export class KvBnrSavedBerichteStore extends BaseCachedEntityStore<SavedBerichtModel> {
	idProp: string = 'id';
	apiPath = 'api/kv_bnr/saved_berichte';

	createInstances(opts: any): SavedBerichtModel {
		return new SavedBerichtModel(opts);
	}
}
